import {useMutation} from '@apollo/client'
import {Button, Modal, Spinner} from 'react-bootstrap'
import {ANULAR_VALIDATION} from '../../../graphql/mutations/validationMutations'
import {parseId} from '../../../helpers'
import {useEffect} from 'react'
import {toast} from 'react-toastify'
import {IResAnular} from '../../../graphql/types/validationsTypes'

interface IModalProps {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
  id: string
}

export const ModalAnularValidation: React.FC<IModalProps> = ({id, isOpen, onClose, refetch}) => {
  const [gqlAnular, {data, error, loading}] = useMutation<IResAnular>(ANULAR_VALIDATION)

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.identityValidationAnnular.success) {
      toast.success('Validación anualada correctamente')
      refetch()
      onClose()
    } else if (data.identityValidationAnnular.error) {
      toast.error(`Error: ${data.identityValidationAnnular.error.message}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleAnular = () => {
    gqlAnular({
      variables: {
        input: {
          identityValidationId: parseId(id),
        },
      },
    })
  }

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header onHide={onClose}>
        <Modal.Title>Anular validación</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h3>¿Seguro que desea anular esta validación?</h3>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} variant='light'>
          Cancelar
        </Button>
        <Button variant='danger' onClick={handleAnular} disabled={loading}>
          {loading && <Spinner animation='border' size='sm' className='me-2' />}
          Anular
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
